/**
 * Which lab a browser session belongs to.
 *
 * The app is served per lab as `<lab>.dormotech.app`, so the subdomain is the
 * tenant key. It is the one dimension every report can be split by, and it is
 * also how a lab's own GA4 property is looked up in `measurement-targets.ts`.
 */
import { LOCAL_LAB, MAIN_LAB } from './analytics.constants';
import type { LabKey } from './analytics.types';

/** Hosts that are a developer's machine rather than a lab. */
function isDevelopmentHost(hostname: string): boolean {
  return (
    !hostname ||
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    /^\d+(\.\d+){3}$/.test(hostname)
  );
}

/**
 * Lab key for the host being served:
 *  - `sleepcenter.dormotech.app` → `sleepcenter`
 *  - `dormotech.app` / `www.dormotech.app` → `main`
 *  - `localhost`, an IP, or nothing → `local`
 */
export function resolveAnalyticsLab(hostname: string): LabKey {
  if (isDevelopmentHost(hostname)) return LOCAL_LAB;

  const parts = hostname.split('.');
  const subdomain = parts.length > 2 ? parts[0] : null;
  return subdomain && subdomain !== 'www' ? subdomain : MAIN_LAB;
}
